module.exports = __webpack_public_path__ + "static/media/Articles 2.c8a9710c.svg";